// src/mixins/formMixin.js
import emailjs from '@emailjs/browser';

export default {
  data() {
    return {
      showMessage: false,
      resultMessage: "",
      formError: false,
    };
  },
  methods: {
    async submitForm() {
      try {
        // Display a loading message or spinner if desired
        this.resultMessage = "Processing your request...";
        this.formError = false;
        this.showMessage = true;

        // Send form data via emailjs
        await emailjs.sendForm(
          'service_ld204em',
          'template_npk679s',
          this.$refs.form,
          '8hQ2kfs578CK2RzZ4'
        );

        // If successful, update the result message
        this.resultMessage =
          "Thank you! Your message has been received. We'll contact you soon.";
        this.formError = false;
        this.$refs.form.reset();
      } catch (error) {
        // If there is an error, update the result message
        this.resultMessage =
          "Oops! There was an error submitting your request. Please try again later.";
        this.formError = true;
        console.error('Submission failed:', error);
      } finally {
        // Hide the message after 5 seconds
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
      }
    },
  },
};
